import React, { useState } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import Header from './UI/Header';
import Footer from './UI/Footer';
import Toast from './UI/Toast';
import { ToastProvider } from '../context/ToastContext';

const Layout = ({ children }) => {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const hideFooter = location.pathname.startsWith('/event-builder');

  return (
    <ToastProvider>
      <div className="flex flex-col min-h-screen">
        <Header setHeaderHeight={setHeaderHeight} />
        <main
          className="container mx-auto px-4 flex-grow"
          style={{ paddingTop: `${headerHeight}px` }}
        >
          {children}
        </main>
        {!hideFooter && <Footer />}
        <Toast />
      </div>
    </ToastProvider>
  );
};

export default Layout;
